import {
    Brush,
    DeleteOutlined,
    DriveFileMoveOutlined,
    DriveFileRenameOutlineOutlined, FileCopyOutlined,
    FileDownloadOutlined,
    FolderCopyOutlined, Preview, UnarchiveOutlined, ArrowForward
} from "@mui/icons-material";
import * as React from "react";
import {PERMISSIONS} from "../../config/appConst";

export const ACTIONS = {
    FOLDER_COPY: 'FOLDER_COPY',
    FOLDER_MOVE: 'FOLDER_MOVE',
    FOLDER_RENAME: 'FOLDER_RENAME',
    FOLDER_DELETE: 'FOLDER_DELETE',
    FOLDER_EXPLORE: 'FOLDER_EXPLORE',
    FILE_DOWNLOAD: 'FILE_DOWNLOAD',
    FILE_COPY: 'FILE_COPY',
    FILE_MOVE: 'FILE_MOVE',
    FILE_RENAME: 'FILE_RENAME',
    FILE_DELETE: 'FILE_DELETE',
    // FILE_PREVIEW: 'FILE_PREVIEW',
    IMAGE_EDIT: 'IMAGE_EDIT',
    FILE_UNCOMPRESS: 'FILE_UNCOMPRESS',
    FILE_CAD: 'FILE_CAD'
}
export const options = {
    'folder': [
        {
            action: 'FOLDER_EXPLORE',
            text: 'Explore',
            icon: <ArrowForward fontSize="small"/>,
            permissions: [PERMISSIONS.WRITE]
        },
        {
            action: 'FOLDER_COPY',
            text: 'Copy',
            icon: <FolderCopyOutlined fontSize={"small"}/>,
            permissions: [PERMISSIONS.WRITE]
        },
        {
            action: 'FOLDER_MOVE',
            text: 'Move',
            icon: <DriveFileMoveOutlined fontSize={"small"}/>,
            permissions: [PERMISSIONS.WRITE]
        },
        {
            action: 'FOLDER_RENAME',
            text: 'Rename',
            icon: <DriveFileRenameOutlineOutlined fontSize={"small"}/>,
            permissions: [PERMISSIONS.WRITE]
        },
        {
            action: 'FOLDER_DELETE',
            text: 'Delete',
            icon: <DeleteOutlined fontSize={"small"}/>,
            permissions: [PERMISSIONS.WRITE]
        }
    ],
    'file': [
        {
            action: 'FILE_DOWNLOAD',
            text: 'Download',
            icon: <FileDownloadOutlined fontSize={"small"}/>,
            permissions: [PERMISSIONS.WRITE, PERMISSIONS.VIEW]
        },
        {
            action: 'FILE_COPY',
            text: 'Copy',
            icon: <FileCopyOutlined fontSize={"small"}/>,
            permissions: [PERMISSIONS.WRITE]
        },
        {
            action: 'FILE_MOVE',
            text: 'Move',
            icon: <DriveFileMoveOutlined fontSize={"small"}/>,
            permissions: [PERMISSIONS.WRITE]
        },
        {
            action: 'FILE_RENAME',
            text: 'Rename',
            icon: <DriveFileRenameOutlineOutlined fontSize={"small"}/>,
            permissions: [PERMISSIONS.WRITE]
        },
        {
            action: 'FILE_DELETE',
            text: 'Delete',
            icon: <DeleteOutlined fontSize={"small"}/>,
            permissions: [PERMISSIONS.WRITE]
        },
        // {
        //     action: 'FILE_PREVIEW',
        //     text: 'Preview',
        //     icon: <Preview fontSize={"small"}/>,
        //     permissions: [PERMISSIONS.WRITE, PERMISSIONS.VIEW]
        // },
        {
            action: 'IMAGE_EDIT', 
            text: 'Edit', 
            icon: <Brush fontSize={"small"}/>, 
            permissions: [PERMISSIONS.WRITE]
        },
        {
            action: 'FILE_UNCOMPRESS',
            text: 'Uncompress',
            icon: <UnarchiveOutlined fontSize={"small"}/>,
            permissions: [PERMISSIONS.WRITE]
        },
        // { action: 'FILE_CAD', text: 'CAD', icon: <MiscellaneousServicesOutlined fontSize={"small"}/>}
    ]
};

export const ALLOWED_PREV_EXT = ['png', 'jpeg', 'jpg', 'png', 'ico', 'stl', 'obj'];
export const ALLOWED_IMAGE_EDIT_EXT = ['png', 'jpeg', 'jpg', 'png'];
export const ALLOWED_UNCOMPRESS_EXT = ['7z', 'lzma', 'cab', 'zip', 'gzip', 'bzip2', 'z', 'tar'];
export const ALLOWED_CAD_EXT = ['stl', 'obj'];
